"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _app = require("./app");
Object.keys(_app).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _app[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _app[key];
        }
    });
});
